import React from "react";
import { useTranslation } from "react-i18next";

export const EmptyChatBox = ({}) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <div className="conversation-container content-center text-center">
      <span className="pb-4 font-bold text-xl">{t("communityChat.noChatsYet")}</span>
      <p className="mb-8 opacity-70 text-md">
        {t("communityChat.noConversationsHint")}
      </p>
    </div>
  );
};
